import { render } from "./admin.vue?vue&type=template&id=353594f9&scoped=true"
import script from "./admin.vue?vue&type=script&lang=js"
export * from "./admin.vue?vue&type=script&lang=js"

import "./admin.vue?vue&type=style&index=0&id=353594f9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-353594f9"

export default script